import Vue from 'vue'
import BimToast from '@/components/ui/bimToast/bimToast'

function toastHandler (text, settings = {}) {
  const { position = 'bottomEnd' } = settings
  const containerId = 'bim-toast-wrapper__' + position

  // если еще не добавлена в body, то добавляем
  if (!document.getElementById(containerId)) {
    const wrapper = document.createElement('div')

    wrapper.setAttribute('id', containerId)
    wrapper.classList.add('bim-toast-wrapper')

    const stylePosition = position === 'bottomEnd'
      ? 'bottom: 20px; right: 20px;'
      : position === 'topEnd'
        ? 'top: 20px; right: 20px;'
        : position === 'bottomStart'
          ? 'bottom: 20px; left: 20px;'
          : position === 'topStart'
            ? 'top: 20px; left: 20px;'
            : 'top: 50%; left: 50%; transform: translate(-50%, -50%);'

    wrapper.setAttribute('style', 'position: fixed;' + stylePosition)

    document.body.appendChild(wrapper)
  }

  // Рендерим компонент
  const component = new Vue({
    render: h => h(
      BimToast,
      {
        props: { text, ...settings }
      }
    ),
  }).$mount()

  // Добавляем его в обертку #toast-wrapper созданную выше
  document.querySelector(`#${containerId}`).appendChild(component.$el)

  // Вычисляем количество тостов в обертке
  const toastsCounter = document.querySelector(`#${containerId}`).childElementCount

  // Находим последнего ребенка
  const lastChild = document.querySelector(`#${containerId}`).firstElementChild

  // Если количество тостов больше трех то отрабатываем анимацию удаления и дестроим компонент
  if (toastsCounter > 3) {
    lastChild.classList.add('slide-leave-active') // анимация

    setTimeout(() => {
      component.$el.parentNode.removeChild(component.$el.parentNode.childNodes[0]) // дестрой
    }, 300)
  }

  return component
}

/* Успех */
toastHandler.success = (text, settings = {}) => {
  const _title = settings.title || 'Отлично!'
  return toastHandler(
    text,
    {
      ...settings,
      title: _title,
      toastClass: 'success'
    }
  )
}

/* Ошибка */
toastHandler.error = (text, settings = {}) => {
  const _title = settings.title || 'Ошибка'
  return toastHandler(
    text,
    {
      ...settings,
      title: _title,
      toastClass: 'error'
    }
  )
}

export default {
  install (Vue) {
    Vue.prototype.$toast = toastHandler
  }
}
